import {useState, useEffect} from 'react';
import {useSelector, useDispatch} from 'react-redux';
import Selector from '../../../../selectors/pages/deposit/paypal';
import {getPayPalLinks, approvePayPalOrder, createPayPalOrder} from '../../../../reducers/app/actions';
import {useNavigate} from 'react-router-dom';

import LoaderPage from '../../../components/loader_page';

import Enter from './enter';
import Send from './send';
import Alert from './alert';

export default ({setMethod}) => {
    const {paypal_links, paypal_order} = useSelector(Selector);

    const dispatch = useDispatch(),
          navigate = useNavigate();

    const [stage, setStage] = useState('enter'),
          [data, setData] = useState(null);

    useEffect(() => {
        if(!paypal_links)
            dispatch(getPayPalLinks(navigate));
    }, [paypal_links]);

    if(!paypal_links)
        return <LoaderPage />;

    if(stage === "enter")
        return <Enter amounts={Object.keys(paypal_links).map(a => parseInt(a))} setMethod={setMethod} onNext={data => {
            dispatch(createPayPalOrder({
                amount: data.amount,
                sender: data.name
            }, navigate));

            setTimeout(() => {
                setData(data);
                setStage('send');
            }, 500);
        }} />

    if(stage === "send") {
        if(!paypal_order) {
            return <></>;
        } else {
            return <Send data={data} links={paypal_links} onPayment={() => {
                dispatch(approvePayPalOrder(paypal_order.paymentId, navigate));
                setStage('alert');
            }} />;
        }
    }

    return <Alert order={paypal_order} />
}